import { IRoute } from "../../../common/helpers/routesMapper";
import withRouter from "../../utils/withRouter";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";

import { post } from "../../actions/general";
import { editUser } from "../../store/user/actions";

import { seo } from "../../../common/helpers/seo";
import { IUser } from "../../store/user/models";
import { IStateTree } from "../../store/interfaces";

import lazyComponent from "./lazy";


const mapStateToProps = ({ user }: IStateTree) => ({ user: user as IUser });

export default {
    component: withRouter(connect(mapStateToProps, { post, editUser })(injectIntl(lazyComponent))),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["menu.account"], allMessage, lang });
    },
} satisfies IRoute;
